import { TransitionCondition } from '@/features/analyze/types';
import { atom, useAtom, useAtomValue } from 'jotai';

const transitionConditionAtom = atom<TransitionCondition>({
  rangeGap: 'QUARTER',
});

export const useTransitionConditionAtomValue = () =>
  useAtomValue(transitionConditionAtom);

export const useTransitionConditionAtom = () =>
  useAtom(transitionConditionAtom);
